import CustomScroll from '@src/component/customScroll';
import { memo, useEffect, useState } from 'react';
import { Image, Toast } from 'antd-mobile';
import './index.scss';
import { goto } from '@src/route';
import { userInfo as userStatus } from '@src/assets/JSON/Picker.json';
import store from '@src/util/store';
import {
  preSubmitInsured,
  loadList,
  getState,
  checkQuaStatus,
} from '@src/service/ownService';
import touxiang from '@src/assets/image/touxiang.png';
const MiAging = () => {
  const [userInfo, setUser] = useState<any>({head:store.get('head_img') });
  // const [ztName, setZtName] = useState<string>("")

  useEffect(() => {
    document.title = '我的金融分期';
  }, []);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const data = await getState();
      store.set('head_img', data.head);
      setUser(data);
    } catch (err: any) {
      Toast.show(err?.errmsg);
    }
  };

  // const getZtName = async () => {
  //   try {
  //     const qrs = await qualificationResult()
  //     if (qrs?.isCreditCard && qrs?.creditLimitType) {
  //       setZtName("信用卡")
  //     }
  //   } catch (error: any) {
  //     Toast.show(error?.errmsg || "")
  //   }
  // }

  const setStatusText = (status?: string, statusType?: string): string => {
    if (statusType && (status || status == '0')) {
      const obj = userStatus[statusType];
      if (obj) {
        let key = -1;
        obj.key.find((res: number | string, index: number) => {
          if (res == status) {
            key = index;
          }
        });
        if (key > -1) {
          return obj.label[key];
        }
      }
    }
    return '';
  };
  /**
   * 判断是否能去分期申请页面
   */
  const toBankCard = async () => {
    try {
      Toast.show({
        icon: 'loading',
        content: '加载中…',
        duration: 0,
        maskClickable: false,
      });
      const res: any = await preSubmitInsured();
      Toast.clear();
      goto(
        `/apply/w1?loanId=${
          res.loanId ? encodeURIComponent(res.loanId) : ''
        }&no=${res.no as string}`
      );
    } catch (err: any) {
      Toast.show(err?.errmsg || '请求失败');
    }
  };

  // 跳转去金融方案
  const affirm = async () => {
    Toast.show({
      icon: 'loading',
      content: '加载中…',
      duration: 0,
      maskClickable: false,
    });
    try {
      const { rows } = await loadList({
        financePlanStatus: '-1',
        pages: 1,
        rows: 100,
      });
      Toast.clear();
      const find = rows.find((res: any) => res.financePlanStatus == 2);
      Toast.show({
        icon: 'loading',
        content: '加载中…',
        duration: 0,
        maskClickable: false,
      });
      checkQuaStatus()
        .then((res: any) => {
          Toast.clear();
          const { code } = res || {};
          if (code === 999) {
            Toast.show(res.msg);
            return;
          }
          goto('/order/applyDetail', {
            loanid: find?.id,
            status: 2,
            type: 'finanPlan',
          });
        })
        .catch((err: any) => {
          Toast.show(err?.errmsg || '申请状态查询失败！');
        });
    } catch (err: any) {
      Toast.show(err?.errmsg);
    }
  };
  return (
    <div className="page bottomFit MiAging">
      <CustomScroll>
        <div className="all-box">
          <header>
            <div className="header-icon">
              <Image
                src={userInfo?.head || touxiang}
                fallback={<img src={touxiang} alt=""></img>}
                width={63}
                height={63}
                fit="cover"
                style={{ borderRadius: 32 }}
              />
            </div>
            <div className="header-text">
              <p>{userInfo?.nickname}</p>
              <p>{userInfo?.phone}</p>
              <h1>{setStatusText(userInfo?.status, userInfo?.statusType)}</h1>
            </div>
            <div className="header-btn">
              {/* <div>去修改资料</div>
              <div>去申请分期</div> */}
              {userInfo?.statusType == 'QUALIFICATION_STATUS' &&
                userInfo?.status == '3' && (
                  <div
                    onClick={() => {
                      goto('/uploadId');
                    }}
                  >
                    去修改资料
                  </div>
                )}
              {((userInfo?.statusType == 'LOAN_STATUS' &&
                userInfo?.status == '0') ||
                (userInfo?.statusType == 'QUALIFICATION_STATUS' &&
                  userInfo?.status == '1')) && (
                <div
                  onClick={() => {
                    toBankCard();
                  }}
                >
                  去申请分期
                </div>
              )}
              {userInfo?.statusType == 'FINANCE_PLAN_STATUS' &&
                userInfo?.status == '2' && (
                  <div
                    onClick={() => {
                      affirm();
                    }}
                  >
                    确认金融方案
                  </div>
                )}
            </div>
          </header>
          <section>
            <div className="float-box">
              <div className="list-box">
                <ul>
                  <li
                    onClick={() => {
                      goto('/order/miApply');
                    }}
                  >
                    <i className="listIcon1"></i>
                    <div>分期申请</div>
                  </li>
                  {/* <Divider /> */}
                  <li
                    onClick={() => {
                      goto(
                        '/order/finanSchedule?status=financePlanStatus&type=finanPlan'
                      );
                    }}
                  >
                    <i className="listIcon2"></i>
                    <div>金融方案</div>
                  </li>
                  <li
                    onClick={() => {
                      goto(
                        '/order/finanSchedule?status=contractInfoStatus&type=contractInfo'
                      );
                    }}
                  >
                    <i className="listIcon3"></i>
                    <div>融租合同</div>
                  </li>
                  <li
                    onClick={() => {
                      goto(
                        '/order/finanSchedule?status=grantApplyStatus&type=grantApply'
                      );
                    }}
                  >
                    <i className="listIcon4"></i>
                    <div>放款申请</div>
                  </li>
                </ul>
              </div>
            </div>
          </section>
        </div>
      </CustomScroll>
    </div>
  );
};

export default memo(MiAging);
